var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Agreed-upon Purchase Price"}},[_c('div',{staticClass:"flex flex-1 justify-between -mt-4"},[_c('div',{staticClass:"w-56"},[_c('input-money',{attrs:{"name":"purchase_price","read_only":_vm.read_only},model:{value:(_vm.purchase_price),callback:function ($$v) {_vm.purchase_price=$$v},expression:"purchase_price"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }